__turbopack_context__.v({
  "disclaimer": "disclaimers-module-scss-module__XZ2plG__disclaimer",
  "disclaimer-link": "disclaimers-module-scss-module__XZ2plG__disclaimer-link",
  "disclaimerContainer": "disclaimers-module-scss-module__XZ2plG__disclaimerContainer",
  "disclaimerFirstRow": "disclaimers-module-scss-module__XZ2plG__disclaimerFirstRow",
  "disclaimerItem": "disclaimers-module-scss-module__XZ2plG__disclaimerItem",
  "disclaimerList": "disclaimers-module-scss-module__XZ2plG__disclaimerList",
});
